module.exports = __webpack_public_path__ + "static/media/groupedlist.a6a1e413.png";